export { default } from "./ExternalApiConfig.vue";
